/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseWorkingTime
 */
export interface GetConfig200ResponseWorkingTime {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseWorkingTime
     */
    end?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseWorkingTime
     */
    timezone?: string | null;
}

/**
 * Check if a given object implements the GetConfig200ResponseWorkingTime interface.
 */
export function instanceOfGetConfig200ResponseWorkingTime(value: object): value is GetConfig200ResponseWorkingTime {
    return true;
}

export function GetConfig200ResponseWorkingTimeFromJSON(json: any): GetConfig200ResponseWorkingTime {
    return GetConfig200ResponseWorkingTimeFromJSONTyped(json, false);
}

export function GetConfig200ResponseWorkingTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseWorkingTime {
    if (json == null) {
        return json;
    }
    return {
        
        'end': json['end'] == null ? undefined : json['end'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

export function GetConfig200ResponseWorkingTimeToJSON(json: any): GetConfig200ResponseWorkingTime {
    return GetConfig200ResponseWorkingTimeToJSONTyped(json, false);
}

export function GetConfig200ResponseWorkingTimeToJSONTyped(value?: GetConfig200ResponseWorkingTime | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'end': value['end'],
        'timezone': value['timezone'],
    };
}

